import HomeScreenTabs from './HomeScreenTabs';

export default HomeScreenTabs;
